import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import LoginPage from "../views/login/LoginPage.vue";
import EntityPage from "../views/entities/EntityPage.vue";
import EntityFormPage from "../views/entities/EntityFormPage.vue";
import ActionResultFullscreen from "../views/ActionResultFullscreen.vue";
import ConfirmAuthPage from "../views/confirmAuth/ConfirmAuthPage.vue";
import UserByGroup from "../views/user/UserByGroup.vue";
import GruposPage from '../views/user/UserPage.vue';
import UserGroupPage from '../views/user/UserGroupPage.vue';
import ConfigAuthPage from "../views/confirmAuth/ConfigAuthPage.vue";
import PerfilUser from "../views/Perfil/PerfilUser.vue";
import UpdatePasswordPage from "../views/Perfil/UpdatePasswordPage"
import AccountProfilePage from "../views/accountProfile/accountProfilePage.vue";
import firstAccessPage from "../views/firstAccess/firstAccessPage.vue";
import PivoTableView from "../views/pivoTable/PivoTableView.vue";
import CustomizationPage from '../views/customization/CustomizationPage.vue'
import SearchQR from '@/views/searchQR/SearchQR'
import ChangePassword from "@/views/changePassword/ChangePassword.vue";
import WeeklyScheduleView from "@/views/weeklyschedule/WeeklyScheduleView.vue";
import Dashboard from "../views/dashboard/dashboard.vue";
// Pagina não encontrada
import PaginaNaoEncontradaView from "../views/PaginaNaoEncontrada/PaginaNaoEncontradaView.vue";
// Paginas de Jobs
import JobView from "@/views/Job/JobView.vue";
import JobParcelasView from "../views/JobParcelas/JobParcelasView.vue";
// PAGINAS DE COMPRAS
import DistribuicaoDeRequisicaoDeCompraView from "../views/DistribuicaoDeRequisicaoDeCompra/DistribuicaoDeRequisicaoDeCompraView.vue";
import CriarCotacaoDePedidoDeCompraView from "../views/CriarCotacaoDePedidoDeCompra/CriarCotacaoDePedidoDeCompraView.vue";
import CriarPedidoDeCompraView from "../views/CriarPedidoDeCompra/CriarPedidoDeCompraView.vue"
import PedidoDeCompraAlterarPedidoDeCompraView from "../views/PedidoDeCompraAlterarPedidoDeCompra/PedidoDeCompraAlterarPedidoDeCompraView.vue"
import PedidoDeCompraVisualizarPedidosDeCompraView from "../views/PedidoDeCompraVisualizarPedidosDeCompra/PedidoDeCompraVisualizarPedidosDeCompraView.vue";
import PedidoDeCompraAprovacaoCoordenadoresView from "../views/PedidoDeCompraAprovacaoCoordenadores/PedidoDeCompraAprovacaoCoordenadoresView.vue";
import PedidoDeCompraAprovacaoDiretorView from "../views/PedidoDeCompraAprovacaoDiretor/PedidoDeCompraAprovacaoDiretorView.vue"
import PedidoDeCompraAprovacaoCompradorView from "../views/PedidoDeCompraAprovacaoComprador/PedidoDeCompraAprovacaoCompradorView.vue";
import PedidoDeCompraEnviarPedidoView from "../views/PedidoDeCompraEnviarPedido/PedidoDeCompraEnviarPedidoView.vue";
import PedidoDeCompraCriarFollowUpView from "../views/PedidoDeCompraCriarFollowUp/PedidoDeCompraCriarFollowUpView.vue";
import PedidoDeCompraSolicitarRevisao from "../views/PedidoDeCompraSolicitarRevisao/PedidoDeCompraSolicitacarRevisaoView.vue";
import PedidoDeCompraRevisaoDePedidoDeCompraView from "../views/PedidoDeCompraRevisaoDePedidoDeCompra/PedidoDeCompraRevisaoDePedidoDeCompraView.vue";
// CONTAS A PAGAR
import ContasAPagarView from "../views/ContasAPagar/ContasAPagarView.vue";
// PAGAMENTOS ELETRONICOS
import PagamentosEletronicosRHPagamentosEletronicosView from "../views/PagamentosEletronicosRHPagamentosEletronicos/PagamentosEletronicosRHPagamentosEletronicosView.vue";
import PagamentosEletronicosFinanceiroPagamentosEletronicosView from "../views/PagamentosEletronicosFinanceiroPagamentosEletronicos/PagamentosEletronicosFinanceiroPagamentosEletronicosView.vue";
import PagamentosEletronicosVisualizarPagamentosEletronicosView from "../views/PagamentosEletronicosVisualizarPagamentosEletronicos/PagamentosEletronicosVisualizarPagamentosEletronicosView.vue";
// CONTAS A RECEBER
import ContasAReceberView from "@/views/ContasAReceber/ContasAReceberView.vue";
//
import OrdemDeServicoLiberarItensView from "../views/OrdemDeServicoLiberarItens/OrdemDeServicoLiberarItensView.vue";
//
import ScheduleJOBView from '../views/ScheduleJOB/ScheduleJobView.vue'
import PGPView from "../views/PGP/PGPView.vue";
import PAVView from "../views/PAV/PAVView.vue";
import RIDListView from "../views/RID/RIDListView.vue"
import RIDCreateView from "../views/RID/RIDCreateView.vue"
import MovimentacaoDeEstoque from '../views/MovimentacaoDeEstoque/MovimentacaoDeEstoqueListView.vue'
import RecebimentoDeNotaFiscalListView from "../views/RecebimentoDeNotaFiscal/RecebimentoDeNotaFiscalListView.vue";
import ItensWarehouseView from "../views/ItensWarehouse/ItensWarehouseView.vue"
import ItensRE from "../views/itensRE/ItensREView.vue"
import PackingListEmbView from "../views/packingListEmb/PackingListEmbView.vue";
import AprovarNotasFiscaisDeServico from "../views/AprovarNotasFiscaisDeServico/AprovarNotasFiscaisDeServico.vue";
import RelatorioUserView from "../views/RelatorioUser/RelatorioUserView.vue";
import RelatorioFornecedorView from "../views/RelatorioFornecedor/RelatorioFornecedorView.vue";
import IssuanceInvoiceView from "../views/IssuanceInvoice/IssuanceInvoiceView.vue";
import RelatorioJobView from "../views/relatorioJob/RelatorioJobView.vue";
import JobCodeView from "../views/relatorioJob/JobCodeView.vue";
import RelatorioOS from "../views/relatorioOS/RelatorioOSPage.vue";
import RelatorioSalesOrder from "../views/relatorioSalesOrder/RelatorioSalesOrderView.vue";
import RelatoriosHomeView from "../views/Relatorios/RelatoriosHomeView.vue";
import RelatorioNFRecebidaView from "../views/Relatorios/NFRecebida/RelatorioNFRecebidaView.vue";
import RelatorioMovimentoFinanceiroView from "../views/Relatorios/MovimentoFinanceiro/RelatorioMovimentoFinanceiroView.vue";
import RelatorioContasAPagarView from "../views/Relatorios/ContasAPagar/RelatorioContasAPagarView.vue";
import RelatorioNFEmitidaView from "../views/Relatorios/NFEmitida/RelatorioNFEmitidaView.vue";
import RelatorioContasAReceberView from "../views/Relatorios/ContasAReceber/RelatorioContasAReceberView.vue";
import RelatorioComercialSalesOrderView from "../views/Relatorios/Comercial/RelatorioComercialSalesOrderView.vue";
import RelatorioEstoqueView from "../views/Relatorios/Estoque/RelatorioEstoqueView.vue";
import RelatorioComercialJobView from "../views/Relatorios/Comercial/RelatorioComercialJobView.vue";
import RelatorioComercialOSView from "../views/Relatorios/Comercial/RelatorioComercialOSView.vue";
// CUSTOM VIEWS
import DesenhoNumberView from "../views/DesenhoNumber/DesenhoNumberView.vue";
import SolicitacaoDeOrcamentoView from "../views/SolicitacaoDeOrcamento/SolicitacaoDeOrcamentoView.vue";

Vue.use(VueRouter);

const router = new VueRouter({
    //mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "Login",
            component: LoginPage,
        },
        {
            path: "/home",
            name: "Home",
            component: Home,
            children: [
                {
                    path: "/entity/:schemaName",
                    name: "Entity",
                    component: EntityPage,
                    props: true,
                },
                {
                    path: "/entity/form/:schemaName/:id?",
                    name: "EntityForm",
                    component: EntityFormPage,
                    props: true,
                },
                {
                    path: "/action/result",
                    name: "ActionResult",
                    component: ActionResultFullscreen,
                },
                {
                    path: "/s",
                    name: "SearchQR",
                    component: SearchQR,
                },
                {
                    path: "/userPage",
                    name: "UserPage",
                    component: UserByGroup,
                },
                {
                    path: "/accountProfile",
                    name: "AccountProfilePage",
                    component: AccountProfilePage,
                },
                {
                    path: "/configAuth/",
                    name: "ConfigAuthPage",
                    component: ConfigAuthPage,
                },
                {
                    path: "/users/:groupName/:id",
                    name: "UserGroupPage",
                    component: UserGroupPage,
                },
                {
                    path: "/grupos",
                    name: "userGroups",
                    component: GruposPage
                },
                {
                    path: "/dashboard",
                    name: "Dashboard",
                    component: Dashboard,
                },
                {
                    path: "/perfilUser",
                    name: "PerfilUserPage",
                    component: PerfilUser,
                },
                {
                    path: "/updatePassword",
                    name: "UpdatePasswordPage",
                    component: UpdatePasswordPage,
                },
                {
                    path: "/pivoTable/:viewId/:viewName",
                    name: "PivoTableView",
                    component: PivoTableView,
                    props: true
                },
                {
                    path: "/customization",
                    name: "Customization",
                    component: CustomizationPage
                },
                {
                    path: "/weeklySchedule",
                    name: "WeeklySchedule",
                    component: WeeklyScheduleView
                },
                {
                    path: "/PGP",
                    name: "PGP",
                    component: PGPView
                },
                {
                    path: "/PAV",
                    name: "PAV",
                    component: PAVView
                },
                {
                    path: "/RID",
                    name: "RID",
                    component: RIDListView
                },
                {
                    path: "/AprovarNotasFiscaisDeServico",
                    name: "AprovarNotasFiscaisDeServico",
                    component: AprovarNotasFiscaisDeServico
                },
                    {
                    path: "/MovimentacaoDeEstoque",
                    name: "MovimentacaoDeEstoque",
                    component: MovimentacaoDeEstoque
                },
                {
                    path: "/RecebimentoDeNotaFiscal",
                    name: "RecebimentoDeNotaFiscal",
                    component: RecebimentoDeNotaFiscalListView
                },
                {
                    path: "/tela/job",
                    name: "Job",
                    component: JobView
                },
                {
                    path: "/tela/job-parcelas",
                    name: "JobParcelas",
                    component: JobParcelasView
                },
                {
                    path: "/tela/distribuicao-de-requisicao-de-compra",
                    name: "DistribuicaoDeRequisicaoDeCompra",
                    component: DistribuicaoDeRequisicaoDeCompraView
                },
                {
                    path: "/tela/criar-cotacao-de-pedido-de-compra",
                    name: "CriarCotacaoDePedidoDeCompra",
                    component: CriarCotacaoDePedidoDeCompraView
                },
                {
                    path: "/tela/criar-pedido-de-compra",
                    name: "CriarPedidoDeCompra",
                    component: CriarPedidoDeCompraView
                },
                {
                    path: "/tela/pedido-de-compra-alterar-pedido-de-compra",
                    name: "PedidoDeCompraAlterarPedidoDeCompra",
                    component: PedidoDeCompraAlterarPedidoDeCompraView
                },
                {
                    path: "/tela/pedido-de-compra-visualizar-pedidos-de-compra",
                    name: "PedidoDeCompraVisualizarPedidosDeCompra",
                    component: PedidoDeCompraVisualizarPedidosDeCompraView
                },
                {
                    path: "/tela/pedido-de-compra-aprovacao-coordenadores",
                    name: "PedidoDeCompraAprovacaoCoordenadores",
                    component: PedidoDeCompraAprovacaoCoordenadoresView
                },
                {
                    path: "/tela/pedido-de-compra-aprovacao-diretor",
                    name: "PedidoDeCompraAprovacaoDiretor",
                    component: PedidoDeCompraAprovacaoDiretorView
                },
                {
                    path: "/tela/pedido-de-compra-aprovacao-comprador",
                    name: "PedidoDeCompraAprovacaoComprador",
                    component: PedidoDeCompraAprovacaoCompradorView
                },
                {
                    path: "/tela/pedido-de-compra-enviar-pedido",
                    name: "PedidoDeCompraEnviarPedido",
                    component: PedidoDeCompraEnviarPedidoView
                },
                {
                    path: "/tela/pedido-de-compra-criar-followup",
                    name: "PedidoDeCompraCriarFollowUp",
                    component: PedidoDeCompraCriarFollowUpView
                },
                {
                    path: "/tela/pedido-de-compra-solicitar-revisao",
                    name: "PedidoDeCompraSolicitarRevisao",
                    component: PedidoDeCompraSolicitarRevisao
                },
                {
                    path: "/tela/pedido-de-compra-revisao-de-pedido-de-compra",
                    name: "PedidoDeCompraRevisaoDePedidoDeCompra",
                    component: PedidoDeCompraRevisaoDePedidoDeCompraView
                },
                {
                    path: "/tela/contas-a-pagar",
                    name: "ContasAPagar",
                    component: ContasAPagarView
                },
                {
                    path: "/tela/pagamentos-eletronicos-rh-pagamentos-eletronicos",
                    name: "PagamentosEletronicosRHPagamentosEletronicos",
                    component: PagamentosEletronicosRHPagamentosEletronicosView
                },
                {
                    path: "/tela/pagamentos-eletronicos-financeiro-pagamentos-eletronicos",
                    name: "PagamentosEletronicosFinanceiroPagamentosEletronicos",
                    component: PagamentosEletronicosFinanceiroPagamentosEletronicosView
                },
                {
                    path: "/tela/pagamentos-eletronicos-visualizar-pagamentos-eletronicos",
                    name: "PagamentosEletronicosVisualizarPagamentosEletronicos",
                    component: PagamentosEletronicosVisualizarPagamentosEletronicosView
                },
                {
                    path: "/tela/contas-a-receber",
                    name: "ContasAReceber",
                    component: ContasAReceberView
                },
                {
                    path: "/scheduleJOB",
                    name: "ScheduleJOB",
                    component: ScheduleJOBView
                },
                {
                    path: "/itensWarehouse",
                    name: "ItensWarehouse",
                    component: ItensWarehouseView
                },
                {
                    path: "/itensRE",
                    name: "ItensRE",
                    component: ItensRE
                },
                {
                    path: "/packingListEmb",
                    name: "PackingListView",
                    component: PackingListEmbView
                },
                {
                    path: "/issuanceIncoice",
                    name: "InssuanceVoiceView",
                    component: IssuanceInvoiceView,
                },
                {
                    path: "/issuanceInvoice/createIssuance/:typeNf",
                    name: "CreateIssuance",
                    component: () => import("../views/IssuanceInvoice/CreateIssuanceInvoiceView.vue"),
                    props: true
                },
                {
                    path: "/relatorioUser",
                    name: "RelatorioUser",
                    component: RelatorioUserView
                },
                {
                    path: "/relatorioFornecedor",
                    name: "RelatorioFornecedor",
                    component: RelatorioFornecedorView
                },
                {
                    path: "/relatorioJob",
                    name: "RelatorioJOB",
                    component: RelatorioJobView
                },
                {
                    path: "/relatorioOS",
                    name: "relatorioOS",
                    component: RelatorioOS
                },
                {
                    path: "/relatorioSalesOrder",
                    name: "RelatorioSalesOrder",
                    component: RelatorioSalesOrder
                },
                {
                    path: "/relatorios",
                    name: "RelatoriosHome",
                    component: RelatoriosHomeView
                },
                {
                    path: "/relatorios/nf-recebida",
                    name: "RelatorioNFRecebida",
                    component: RelatorioNFRecebidaView
                },
                {
                    path: "/relatorios/movimento-financeiro",
                    name: "RelatorioMovimentoFinanceiro",
                    component: RelatorioMovimentoFinanceiroView
                },
                {
                    path: "/relatorios/contas-a-pagar",
                    name: "RelatorioContasAPagarNovo",
                    component: RelatorioContasAPagarView
                },
                {
                    path: "/relatorios/nf-emitida",
                    name: "RelatorioNFEmitida",
                    component: RelatorioNFEmitidaView
                },
                {
                    path: "/relatorios/contas-a-receber",
                    name: "RelatorioContasAReceberNovo",
                    component: RelatorioContasAReceberView
                },
                {
                    path: "/relatorios/estoque",
                    name: "RelatorioEstoque",
                    component: RelatorioEstoqueView
                },
                {
                    path: "/relatorios/comercial/sales-order",
                    name: "RelatorioComercialSalesOrder",
                    component: RelatorioComercialSalesOrderView
                },
                {
                    path: "/relatorios/comercial/job",
                    name: "RelatorioComercialJob",
                    component: RelatorioComercialJobView
                },
                {
                    path: "/relatorios/comercial/os",
                    name: "RelatorioComercialOS",
                    component: RelatorioComercialOSView
                },
                {
                    path: "/tela/desenho-number",
                    name: "DesenhoNumber",
                    component: DesenhoNumberView
                },
                {
                    path: "/tela/solicitacao-de-orcamento",
                    name: "SolicitacaoDeOrcamento",
                    component: SolicitacaoDeOrcamentoView
                },
                {
                    path: "/tela/ordem-de-servico-liberar-itens",
                    name: "OrdemDeServicoLiberarItens",
                    component: OrdemDeServicoLiberarItensView
                },
                {
                    path: "/tela/*",
                    name: "PaginaNaoEncontrada",
                    component: PaginaNaoEncontradaView
                },
            ],
        },
        {
            path: "/confirmAuth",
            name: "ConfirmAuthPage",
            component: ConfirmAuthPage,
        },
        {
            path: "/firstAccess",
            name: "firstAccess",
            component: firstAccessPage,
        },

        {
            path: "/changePassword",
            name: "ChangePassword",
            component: ChangePassword
        },

        {
            path: "/relatorioJobCode/:id",
            name: "RelatorioJobCode",
            component: JobCodeView
        }

    ]
});

router.beforeEach(async (to, from, next) => {


    let token = await Vue.prototype.$auth.getUserToken();

    if (to.name == "SearchQR" && !token) {

        let href = location.href?.split('/s');
        let s = href[1].split('/#/')
        let newHref = `${href[0]}/#/s${s[0].replace('#/', '')}`

        location.href = newHref
        let url = new URLSearchParams(s[0].replace('?', ''))

        next({
            name: "Login",
            query: { s: 's', v: url.get('v'), t: url.get('t') }
        });
    }

    else if (to.name == "ChangePassword" && !token) {
        next()
    }

    else if (to.name !== "Login" && !token) {
        Vue.prototype.$notfy.error(
            "Sua sessão expirou, falta login novamente"
        );
        //window.setTimeout(() => {
        next({
            name: "Login",
        });
        //}, 1000);
    } else {
        if (to.name === "Login" && token) {
            next({
                name: "Home",
            });
        } else {
            next();
        }
    }

    //} else {
    //  next();
    //}

});

export default router;
